import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { wrapCreateBrowserRouterV6 } from '@sentry/react'
import { ServiceError } from 'entities/Sentry/ui/ServiceError'
import { type EntitiesStore } from 'entities/EntitiesExport'
import { ProviderEntities } from 'entities/EntitiesExport/context/entitiesContext'
import { PresentationModeLayout } from 'widgets/PresentationMode'
import { ProviderCallPopUpGlobal } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import type { CallPopUpGlobalStore } from 'widgets/CallPopUp'
import { PublicAPILayout } from 'app/Integration/service/PublicAPI'
import OverlayLayout from './layouts/OverlayLayout'

const routes = createRoutesFromElements(
  <Route element={<PresentationModeLayout />}>
    <Route element={<PublicAPILayout />}>
      <Route path='/*' element={<OverlayLayout />} errorElement={<ServiceError name='overlay' />} />
    </Route>
  </Route>
)

const router = wrapCreateBrowserRouterV6(createBrowserRouter)(routes)

type IOverlayServiceProps = {
  entities: EntitiesStore
  callPopUpGlobalStore: CallPopUpGlobalStore
}

export const OverlayService = ({ entities, callPopUpGlobalStore }: IOverlayServiceProps) => (
  <ProviderEntities entities={entities}>
    <ProviderCallPopUpGlobal value={callPopUpGlobalStore}>
      <RouterProvider router={router} />
    </ProviderCallPopUpGlobal>
  </ProviderEntities>
)
